<template>
  <div class="home bg" :class="(state.isLoading) ? 'is-loading' : 'loaded'">
      <Stars />
      <CanvasStars />
      <SparkleStars />
      <LandscapeMessage />
      <Header></Header>
      <router-view/>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/particle/Header.vue'
import Stars from '@/components/particle/Stars.vue'
import CanvasStars from '@/components/particle/CanvasStars.vue'
import SparkleStars from '@/components/particle/SparkleStars.vue'
import LandscapeMessage from "../components/particle/LandscapeMessage";

import { inject } from "vue";

export default {
  components: {
    Header,
    Stars,
    CanvasStars,
    SparkleStars,
    LandscapeMessage
  },
  setup() {
    const store = inject("store");
    return {
      state: store.state
    };
  },	
}
</script>

<style scoped lang="scss">
.home {
	transition: opacity 0.25s;
	opacity: 0;
	visibility: hidden;
}
.is-loading {
	visibility: hidden;
}
.loaded {
	visibility: visible;
	opacity: 1;
}
.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}
.bg {
  background-image: url("../assets/imgs/bg.jpg");
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}
@media (max-width: 414px) {
  .bg {
    overflow: hidden;
    background-image: url("../assets/imgs/bg.jpg");
  }
}
</style>